import { Typography } from 'antd';
import * as Component from 'components';
import { observer } from 'mobx-react';
import React from 'react';
import { accountStore } from 'store/accountStore';
import FileUploadCard from './components/FileUploadCard';
import MrssImportCard from './components/MrssImportCard';
import OdkSyncCard from './components/OdkSyncCard';

const { Title } = Typography;

const ImportUpload: React.FC = () => {
  const userPlatform = accountStore.getAccount()!.platform;
  return (
    <Component.BasePageComponent>
      <div className="split-container">
        <Title level={2}>Upload</Title>
        <FileUploadCard platformId={userPlatform.id} />
        {userPlatform.id === 1 && (
          <>
            <Title level={2}>Import</Title>
            <MrssImportCard />
            <Title level={2}>Sync</Title>
            <OdkSyncCard />
          </>
        )}
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(ImportUpload);
